import { render, staticRenderFns } from "./RechargeAspot.vue?vue&type=template&id=5bdf6b53"
import script from "./RechargeAspot.vue?vue&type=script&lang=js"
export * from "./RechargeAspot.vue?vue&type=script&lang=js"
import style0 from "./RechargeAspot.vue?vue&type=style&index=0&id=5bdf6b53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default})
